import { Component, Input, OnInit } from '@angular/core';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { IFeeDetailPrint } from 'app/shared/Domains/feeDetailPrint';
import { Configuration } from 'config/config';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
	selector: 'app-single-receipt-print',
	templateUrl: './single-receipt-print.component.html',
	styleUrls: ['./single-receipt-print.component.css']
})

export class SingleReceiptPrintComponent implements OnInit {
	@Input() company: ICompany;
	@Input() branch: IBranch;
	fee: IFeeDetailPrint;
    invoiceData: any;
	constructor(private LanguageService: LanguageService, public config: Configuration) {

	}

	ngOnInit() {
		console.log("ggg", this.fee);
        this.invoiceData = this.branch.invoiceData;
		this.fee = new IFeeDetailPrint();

	}

	setLabel(label) {
		return this.LanguageService.GetCurrentLanguage("SingleReceiptPrintComponent", label);
	}

	calculateTotalForSinglePrint(fee, tax, discount, taxType) {
		if (tax === undefined || tax === null) {
			tax = 0;
		}
		if (discount === undefined || discount === null) {
			discount = 0;
		}
		if (taxType === 'WITH_TAX') {
			return (parseInt(fee) + parseInt(tax)) - parseInt(discount);
		}
		else {
			return parseInt(fee) - parseInt(discount);
		}
	}

	initiatePrintInvoice(fee) {
		this.fee = fee;
		setTimeout(() => {
			this.printInvoice();
		}, 300);
	}

	printInvoice(): void {
        this.invoiceData = this.branch.invoiceData;
        const printContents = document.getElementById("subscriptionSingleFeePrint").innerHTML;
        const popupWin = window.open(
            "",
            "_blank",
            "top=0,left=0,height=100%,width=auto"
        );
        popupWin.document.open();
        popupWin.document.write(`
    <html>
    <head>
        <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            .heading td {
              font-size: 13px;
            }
            .item td {
                font-size: 13px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `);
    }
}